import { Button, Card, CardContent, Drawer, TextField, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import * as React from "react";
//import TextField, { TextFieldProps } from "@material-ui/core/TextField";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { StyledCard } from '../AccountBasicInfo/AccountBacisInfo.styles';
import CustomDataGrid from '../DataGrid/DataGrid';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import AssignmentIcon from '@mui/icons-material/Assignment';
// import { PermissionsEnum } from "../../utils/auth.types";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import Link from '@mui/material/Link';
import { ApiStatus } from "../../utils/api.types";
import { Utils } from "../../utils/common-utils";
import { GridActionsCellItem, GridColDef, GridValueGetterParams } from '@mui/x-data-grid';
import { AInvoice } from '../../utils/invoice.types';
import { /* deleteBank, */ fetchInvoices } from '../../store/invoiceStore/invoiceThunk';
import moment from 'moment';
import { useNavigate } from "react-router-dom";
//Dropdown imports
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Clear } from "@mui/icons-material";

//collapsible grid imports
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

//Date range picker
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';

//To get buyer list
import { fetchCustomers } from '../../store/customerStore/customerThunk';

//Invoice to payment form 
import InvoiceToPaymentForm from "../Cashflow/DialogInvoiceToPaymentForm";

import AddPaymentForm from "../Cashflow/DialogAddPaymentForm";
import { fetchSuppliers } from '../../store/supplierStore/supplierThunk';
import { fetchCashInflowPaymentsDetails, deletePaymentReceipt } from '../../store/CashInflowStore/cashInflowThunk';
import { deletePaymentReceiptOutflow } from '../../store/CashOutflowStore/cashOutflowThunk';
import CustomSelect, { IOptions } from '../FormFields/CustomSelect';
import { FormProvider, useForm } from 'react-hook-form';
import { fetchCashOutflowPaymentsDetails } from '../../store/CashOutflowStore/cashOutflowThunk';
import { StyledStack } from '../Filters/Filters.styles';
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { LoadingButton } from '@mui/lab';
import generatePDF, { Resolution, Margin, Options } from "react-to-pdf";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

// const statusArr = ["Fully applied","Partially applied","Unapplied"];

// const priceArr = ["1,00,000 - 3,00,000", "3,00,001 - 5,00,000", "5,00,001 - 7,00,000", "7,00,001 - 9,00,000", "9,00,001 & Above"];


const PDF_FONT_SIZE = "0.975rem"

interface PaymentsList {
  accountType: string;
  invoiceId?: string;
  type: string;
}

const CashFlowData: FC<PaymentsList> = (props) => {
  const dispatch = useAppDispatch();
  const { /* permissions, */ selectedAccount } = useAppSelector(state => state.auth);
  const [buyersOrSuppliers, setBuyersOrSuppliers] = useState<any>([]);
  const [statuses, setStatus] = useState<string[]>([]);
  const isInflow = props.type == 'account-receivable' ? true : false;

  const [selectedBuyerOrSupplier, setSelectedBuyerOrSupplier] = useState<any>('');
  const [selectedInvoiceStatus, setSelectedInvoiceStatus] = useState('ALL');
  const [selectedAmountRange, setSelectedAmountRange] = useState('0 - 99999');
  const [startDate, setStartDate] = useState<Date>(new Date(Date.now() - 400 * 24 * 60 * 60 * 1000));
  const [endDate, setEndDate] = useState<Date>(new Date());

  const [openPaymentDrawer, setOpenPaymentDrawer] = useState(false);
  const handleOpenPayment = () => setOpenPaymentDrawer(true);
  const [checkedExpandRow, setCheckedExpandRow] = useState(false);
  
  // Delete confirmation dialog state
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [paymentToDelete, setPaymentToDelete] = useState<string | null>(null);

  const [invoiceStatusOptions, setInvoiceStatusOptions] = useState<IOptions[]>([
    { label: 'ALL', value: 'ALL' },
    { label: 'Fully Applied', value: 'FULLY_APPLIED' },
    { label: 'Partially Applied', value: 'PARTIALLY_APPLIED' },
    { label: 'Unapplied', value: 'UNAPPLIED' },
  ]);

  const [amountRangeOptions, setAmountRangeOptions] = useState<IOptions[]>([
    { label: 'Below 1 Lakh', value: '0 - 99999' },
    { label: '1,00,000 - 3,00,000', value: '100000 - 300000' },
    { label: '3,00,001 - 5,00,000', value: '300001 - 500000' },
    { label: '5,00,001 - 7,00,000', value: '500001 - 700000' },
    { label: '7,00,001 - 9,00,000', value: '700001 - 900000' },
    { label: '9,00,001 & Above', value: '900001 & Above' }
  ]);

  const schema = yup.object().shape({
    base: yup.string().required("Base Amount is required."),
    tax: yup.string().required("Tax is required."),
    tds: yup.string().required("TDS is required."),
  });
  const methods = useForm<any>({ mode: 'onChange', reValidateMode: 'onChange', resolver: yupResolver(schema) });

  const navigate = useNavigate();
  const currentPathName = window.location.href;
  const curPage = currentPathName.split('/');
  const [rows, setRows] = useState<any[]>([]);

  const onClickHandler = () => {
    setStartDate(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000));
    setEndDate(new Date());
  };

  const handleClosePayment = async (val: any) => {
    if (val) {
      getCashInflowPayments();
    }
    setOpenPaymentDrawer(false)
  };

  //Handle date range picker
  const handleDateChange = (newValue: Date | null, name: string | undefined) => {
    if (newValue) {
      if (name === 'startDate')
        setStartDate(newValue);
      else if (name === 'endDate')
        setEndDate(newValue);
    }
  };

  const TabHeading = (props.accountType == "Invoices") ? "" : `${props.accountType} Cash Summary`;

  const userType = (isInflow) ? "Buyer Name" : "Supplier Name";

  useEffect(() => {
    getBuyerOrSupplier();
  }, []);

  useEffect(() => {
    getCashInflowPayments();
  }, [selectedBuyerOrSupplier, selectedInvoiceStatus, startDate, endDate, selectedAmountRange]);

  const getBuyerOrSupplier = async () => {
    console.log('getBuyerOrSupplier called', { isInflow, accountType: props.accountType, type: props.type });
    // Fetch account related customers or suppliers.
    let buyerOrSupplierData: any[] = [];
    const { _id: id } = selectedAccount;
    const cData: any = isInflow ? await dispatch(fetchCustomers(id)) : await dispatch(fetchSuppliers({ accountId: id, params: '' }));
    console.log('Fetched data:', cData);
    buyerOrSupplierData = cData.payload.map((c: any) => {
      // customersData[c._id] = c.name; 
      return { "label": c.name, "value": c._id }
    });
    buyerOrSupplierData = [{ "label": "ALL", "value": "ALL" }, ...buyerOrSupplierData];
    setBuyersOrSuppliers(buyerOrSupplierData);
    console.log('buyerOrSupplierData:', buyerOrSupplierData);
    if (buyerOrSupplierData.length > 0) {
      setSelectedBuyerOrSupplier(buyerOrSupplierData[0].value)
      console.log('Set selectedBuyerOrSupplier to:', buyerOrSupplierData[0].value);
    }
  };

  const getCashInflowPayments = async () => {
    console.log('getCashInflowPayments called', {
      isInflow,
      selectedBuyerOrSupplier,
      accountType: props.accountType,
      type: props.type
    });
    
    let d1: any = null;
    if (!selectedBuyerOrSupplier || selectedBuyerOrSupplier.length == 0) {
      console.log('Early return: selectedBuyerOrSupplier is empty', selectedBuyerOrSupplier);
      return;
    }
    if (isInflow) {
      console.log('Calling fetchCashInflowPaymentsDetails');
      d1 = await dispatch(fetchCashInflowPaymentsDetails({ selectedBuyer: selectedBuyerOrSupplier, selectedInvoiceStatus, startDate, endDate, selectedAmountRange }));
    } else {
      console.log('Calling fetchCashOutflowPaymentsDetails');
      d1 = await dispatch(fetchCashOutflowPaymentsDetails({ selectedBuyer: selectedBuyerOrSupplier, selectedInvoiceStatus, startDate, endDate, selectedAmountRange }));
    }
    console.log(d1)
    setRows(d1.payload.map((d: any) => {
      let invoices = [];
      if (d.invoices && d.invoices.length > 0) {
      invoices = d.invoices.map((i1: any) => {
          let invObj = {
            invoice_no: i1.invoice ? i1.invoice.invoiceNumber : '',
            invoice_date: i1.invoice ? Utils.formatDate(i1.invoice.date) : '',
            invoice_amount: i1.invoice ? i1.invoice.amount : 0,
            applied_base: i1.appliedAmountBase || 0,
            applied_tax: i1.appliedAmountTax || 0,
            applied_tds: i1.appliedAmountTDS || 0,
            applied_amount: i1.appliedAmountTotal || 0
          };
          return invObj;
        
      });
      }
      let paymentStatus = d.applyStatus;
      let name = d.paymentFrom ? d.paymentFrom.name : d.paymentTo.name;
      let buyerOrSupplierId = d.paymentFrom ? d.paymentFrom._id : d.paymentTo._id;
      let bankName = isInflow ? d.fromBankAccount?.bankName : d.toBankAccount?.bankName;
      return createData(d._id, d.txnId, d._id, Utils.formatDate(d.paymentDate), name, buyerOrSupplierId, bankName, d.ref1, d.amount, d.paymentApplied, d.paymentUnapplied, paymentStatus, invoices, d.paymentMode);
    }));
  };

  const exportToExcel = (): void => {
    // Create a worksheet from JSON data
    console.log("exportToExcel == " , rows)
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rows);
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  
    // Write Excel file as a binary array
    const excelBuffer: any = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const dataBlob: Blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  
    // Create an object URL for the Blob
    const fileURL: string = URL.createObjectURL(dataBlob);
  
    // Trigger file download
    saveAs(dataBlob, "table_data.xlsx");
  
    // Delete the file from memory after download
    setTimeout(() => {
      URL.revokeObjectURL(fileURL);
      console.log("File deleted from memory");
    }, 5000); // Delay ensures download completes
  };

  const ExportTable = () => {
    return (
      <div>
        <Button variant="contained" color="primary" onClick={exportToExcel}>
          Export to Excel
        </Button>
      </div>
    );
  };

  function createData(
    name: string,
    txnId: string,
    payment_id: String,
    payment_date: String,
    buyer: String,
    buyerOrSupplierId: string,
    bankInfo: String,
    ref: String,
    payment_amount: String,
    total_applied: String,
    total_unapplied: String,
    payment_status: String,
    invoices: any,
    payment_mode: any
  ) {

    return {
      name,
      txnId,
      payment_id,
      payment_date,
      buyer,
      buyerOrSupplierId,
      bankInfo,
      ref,
      payment_amount,
      total_applied,
      total_unapplied,
      payment_status,
      invoices: invoices,
      payment_mode
    };
  }
  
  const handleChangeExpandRow = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckedExpandRow(event.target.checked);
  };

  // Delete payment handlers
  const handleDeleteClick = (paymentId: string) => {
    setPaymentToDelete(paymentId);
    setDeleteDialogOpen(true);
  };

  const handleDeleteConfirm = async () => {
    if (paymentToDelete) {
      try {
        if (isInflow) {
          await dispatch(deletePaymentReceipt(paymentToDelete));
        } else {
          await dispatch(deletePaymentReceiptOutflow(paymentToDelete));
        }
        // Refresh the payments list
        getCashInflowPayments();
      } catch (error) {
        console.error('Error deleting payment:', error);
      }
    }
    setDeleteDialogOpen(false);
    setPaymentToDelete(null);
  };

  const handleDeleteCancel = () => {
    setDeleteDialogOpen(false);
    setPaymentToDelete(null);
  };

  // Apply payment handler
  const handleApplyPayment = (row: any) => {
    const params = new URLSearchParams({
      paymentId: row.payment_id,
      type: isInflow ? 'inflow' : 'outflow',
      buyerId: row.buyerOrSupplierId,
      buyerName: row.buyer,
      amount: row.total_unapplied,
      date: row.payment_date
    });
    navigate(`/payments/apply?${params.toString()}`);
  };


  function Row(props: { row: ReturnType<typeof createData>, scType: string, expandRow: boolean }) {
    const { row } = props;
    const [open, setOpen] = useState(props.expandRow);

    const [openInvDrawer, setOpenInvDrawer] = useState(false);

    const handleOpen = () => setOpenInvDrawer(true);
    const handleClose = async (val: any) => {
      if (val) {
        const { _id: id } = selectedAccount;
        await dispatch(getCashInflowPayments());
      }
      setOpenInvDrawer(false);
    };

    const numRows = row.invoices.length;
    let i = 0;
    return (
      <React.Fragment >
        <TableRow sx={{ '& > *': { borderBottom: '0px', fontSize: `${PDF_FONT_SIZE}`, fontWeight: '400' } }} key={i}  style={{
                  borderBottom: "1px solid #ddd",
                  padding: "8px",
                  ...(i % 20 === 0 ? { pageBreakAfter: "always" } : {}) // Break after every 20 rows
                }}>
          <TableCell sx={{ borderBottom: 'none' }}>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => { setOpen(!open); }}
            >
              {open ? props.expandRow ? <KeyboardArrowRightIcon /> : <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell align="left" className="tableRowCell" sx={{ fontSize: `${PDF_FONT_SIZE}`, fontWeight: '400', borderBottom: 'none' }}>{row.txnId} </TableCell>
          <TableCell className="tableRowCell" sx={{ fontSize: `${PDF_FONT_SIZE}`, fontWeight: '400', borderBottom: 'none' }}>{row.payment_date} </TableCell>
          <TableCell align="left" className="tableRowCell" sx={{ fontSize: `${PDF_FONT_SIZE}`, fontWeight: '400', borderBottom: 'none', textWrap: 'auto' }}>{row.buyer}</TableCell>
          <TableCell className="tableRowCell" sx={{ fontSize: `${PDF_FONT_SIZE}`, fontWeight: '400', borderBottom: 'none' }}>
            <p className="flex-end">
              {Utils.formatNumber((row.payment_amount) || '0', true, true)}
            </p>
          </TableCell>
          <TableCell align="right" className="tableRowCell" sx={{ fontSize: `${PDF_FONT_SIZE}`, fontWeight: '400', borderBottom: 'none' }}>
            <p className="flex-end">{Utils.formatNumber((row.total_applied) || '0', true, true)}</p>
          </TableCell>
          <TableCell align="right" className="tableRowCell" sx={{ fontSize: `${PDF_FONT_SIZE}`, fontWeight: '400', borderBottom: 'none' }}>
            <p className="flex-end">
              {Utils.formatNumber((row.total_unapplied) || '0', true, true)}
            </p>
          </TableCell>
          <TableCell align="left" className="tableRowCell" sx={{ fontSize: `${PDF_FONT_SIZE}`, fontWeight: '400', borderBottom: 'none' }}>{row.payment_status}</TableCell>
          <TableCell align="left" className="tableRowCell" sx={{ fontSize: `${PDF_FONT_SIZE}`, fontWeight: '400', borderBottom: 'none' }}>{row.payment_mode}</TableCell>
          <TableCell align="center" className="tableRowCell" sx={{ fontSize: `${PDF_FONT_SIZE}`, fontWeight: '400', borderBottom: 'none' }}>
            {/* Apply Payment Button */}
            {/* <IconButton
              size="small"
              onClick={() => handleApplyPayment(row)}
              color="primary"
              title="Apply Payment to Invoices"
              sx={{ mr: 1 }}
            >
              <AssignmentIcon fontSize="small" />
            </IconButton> */}
            {/* {permissions.includes(PermissionsEnum.PAYMENT_DELETE) && ( */}
              <IconButton
                size="small"
                onClick={() => handleDeleteClick(row.payment_id.toString())}
                color="error"
                title="Delete Payment"
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            {/* )} */}
          </TableCell>
        </TableRow>
        <TableRow >
          <TableCell style={{ paddingBottom: 0, paddingTop: 0, paddingLeft: '200' }} colSpan={11}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ borderBottom: '0px' }}>&nbsp;</TableCell>
                      <TableCell className='innerTableHead' sx={{ fontSize: '0.75rem', fontWeight: '700', width: '115px', maxWidth: '150px' }}>Invoice#</TableCell>
                      <TableCell className='innerTableHead' align="right" sx={{ fontSize: '0.75rem', fontWeight: '700', width: '150px', maxWidth: '200px' }} >Invoice Date</TableCell>
                      <TableCell align="right" className='innerTableHead' sx={{ fontSize: '0.75rem', fontWeight: '700', width: '150px', maxWidth: '200px' }} >Invoice Amount</TableCell>
                      <TableCell align="right" className='innerTableHead' sx={{ fontSize: '0.75rem', fontWeight: '700', width: '150px', maxWidth: '200px' }} >Applied Amount</TableCell>
                      <TableCell align="right" className='innerTableHead' sx={{ fontSize: '0.75rem', fontWeight: '700', width: '150px', maxWidth: '200px' }} >Applied Base/ Tax / TDS</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row.invoices.map((invoiceRow: any) => (
                      <TableRow key={i++}>
                        <TableCell sx={{ borderBottom: '0px' }}>&nbsp;</TableCell>
                        <TableCell component="th" scope="row" className="tableRowCell" sx={{ fontSize: `${PDF_FONT_SIZE}`, fontWeight: '400', width: '250px', maxWidth: '250px', borderBottom: 'none' }}>{invoiceRow.invoice_no}</TableCell>
                        <TableCell align="right" className="tableRowCell" sx={{ fontSize: `${PDF_FONT_SIZE}`, fontWeight: '400', width: '115px', maxWidth: '115px', borderBottom: 'none' }}>{invoiceRow.invoice_date}</TableCell>
                        <TableCell align="right" className="tableRowCell" sx={{ fontSize: `${PDF_FONT_SIZE}`, fontWeight: '400', width: '115px', maxWidth: '115px', borderBottom: 'none' }}>{Utils.formatNumber((invoiceRow.invoice_amount) || '0', true, true)}</TableCell>
                        <TableCell align="right" className="tableRowCell" sx={{ fontSize: `${PDF_FONT_SIZE}`, fontWeight: '400', width: '115px', maxWidth: '115px', borderBottom: 'none' }}>{Utils.formatNumber((invoiceRow.applied_amount) || '0', true, true)}</TableCell>
                        <TableCell align="right" className="tableRowCell" sx={{ fontSize: `${PDF_FONT_SIZE}`, fontWeight: '400', width: '115px', maxWidth: '115px', borderBottom: 'none' }}>
                          {Utils.formatNumber((invoiceRow.applied_base) || '0', true, true) + "/ " + Utils.formatNumber((invoiceRow.applied_tax) || '0', true, true) + "/ " + Utils.formatNumber((invoiceRow.applied_tds) || '0', true, true)}
                        </TableCell>
                      </TableRow>
                    ))}
                    {!props.expandRow &&
                    <TableRow>
                      <TableCell align="right" colSpan={6} sx={{ borderBottom: '0px' }}>

                        <Button
                          startIcon={<AddIcon />}
                          variant="contained"
                          color='secondary'
                          onClick={() => setOpenInvDrawer(true)}
                          style={{ fontSize: '14px', width: '220px', height: '35px', justifyContent: 'flex-end', marginRight: '-18px' }}>
                          Apply to another invoice
                        </Button>

                        <Drawer
                          disableEscapeKeyDown={false}
                          anchor="right"
                          open={openInvDrawer}>
                          <InvoiceToPaymentForm
                            isInflow={isInflow}
                            selectedBuyerOrSupplierId={row.buyerOrSupplierId}
                            title='Invoice to payment'
                            open={openInvDrawer}
                            data={row}
                            onClose={handleClose}></InvoiceToPaymentForm>
                        </Drawer>
                      </TableCell>
                    </TableRow>
                    }
                  </TableBody>
                </Table>
                <Typography variant="h6" component="div" sx={{ paddingBottom: '15px' }}></Typography>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  const options: Options = {
    filename: `CashInflow_Statement_${Date.now()}.pdf`,
    method: "save",
    // default is Resolution.MEDIUM = 3, which should be enough, higher values
    // increases the image quality but also the size of the PDF, so be careful
    // using values higher than 10 when having multiple pages generated, it
    // might cause the page to crash or hang.
    resolution: Resolution.NORMAL,
    page: {
      // margin is in MM, default is Margin.NONE = 0
      margin: Margin.MEDIUM,
      // default is 'A4'
      format: "A4",
      // default is 'portrait'
      // orientation: "landscape"
    },
    canvas: {
      // default is 'image/jpeg' for better size performance
      mimeType: "image/jpeg",
      qualityRatio: 1
    },
    // Customize any value passed to the jsPDF instance and html2canvas
    // function. You probably will not need this and things can break,
    // so use with caution.
    overrides: {
      // see https://artskydj.github.io/jsPDF/docs/jsPDF.html for more options
      pdf: {
        compress: true
      },
      // see https://html2canvas.hertzen.com/configuration for more options
      canvas: {
        useCORS: true
      }
    }
  };

  // you can also use a function to return the target element besides using React refs
  const getTargetElement = () => document.getElementById("pdfContainer");

  const downloadPdf = () => {
    
    generatePDF(getTargetElement, options);
  }

  return (
    <>
      <StyledCard sx={{ minHeight: '480px', marginRight: '-5px' }}>
        <CardContent>
          <Typography className={'cardHeader'}>
            <StyledStack>
              <Typography variant="subtitle2" style={{ marginRight: '10px' }}>{'Filter:'}</Typography>
              <FormProvider {...methods}>
                <CustomSelect
                  name="buyer"
                  label={userType}
                  style={{ flex: 1, marginRight: '15px' }}
                  id="buyer"
                  variant="outlined"
                  size='small'
                  options={buyersOrSuppliers}
                  value={selectedBuyerOrSupplier}
                  onChange={(event: SelectChangeEvent<any>) => {
                    setSelectedBuyerOrSupplier(event.target.value)
                  }}
                />

                <CustomSelect
                  name="statuses"
                  label="Statuses"
                  id="statuses"
                  style={{ flex: 1, marginRight: '15px', width: '130px' }}
                  variant="outlined"
                  size='small'
                  options={invoiceStatusOptions}
                  value={selectedInvoiceStatus}
                  onChange={(event: SelectChangeEvent<any>) => {
                    setSelectedInvoiceStatus(event.target.value);
                  }}
                />

                <LocalizationProvider
                  dateAdapter={AdapterDateFns}
                  style={{ flex: 1 }}>
                  <DesktopDatePicker
                    label="Start Date"
                    inputFormat="dd/MM/yyyy"
                    value={startDate}
                    onChange={(value) => { handleDateChange(value, 'startDate') }}
                    renderInput={(params) => <TextField {...params} name={'startDate'} variant="outlined" size='small' style={{ width: '200px', marginRight: '15px', alignSelf: 'flex-end', marginLeft: '-56px' }} />}
                  />
                  <DesktopDatePicker
                    label="End Date"
                    inputFormat="dd/MM/yyyy"
                    value={endDate}
                    onChange={(value) => { handleDateChange(value, 'endDate') }}
                    renderInput={(params) => <TextField {...params} name={'endDate'} variant="outlined" size='small' style={{ width: '200px', marginRight: '15px', alignSelf: 'flex-end' }} />}
                  />
                </LocalizationProvider>

                <CustomSelect
                  name="amountRange"
                  label="Amount Range"
                  id="amountRange"
                  style={{ flex: 1, width: '150px', marginRight: '15px' }}
                  variant="outlined"
                  size='small'
                  options={amountRangeOptions}
                  value={selectedAmountRange}
                  onChange={(event: SelectChangeEvent<any>) => {
                    setSelectedAmountRange(event.target.value);
                  }}
                />
              </FormProvider>
            </StyledStack>
            <Box>
              <div style={{ display: "flex", flexDirection: 'row', justifyContent: 'flex-end', clear: "both" }}>
                <Button
                  startIcon={<AddIcon />}
                  variant="contained"
                  color='secondary'
                  onClick={handleOpenPayment}
                  style={{ fontSize: '14px', height: '35px', alignSelf: 'right', marginTop: '8px' }}
                >
                  {isInflow? 'Receive New Payment': 'Add New Payment'}
                </Button>
                
                <Drawer
                  disableEscapeKeyDown={false}
                  anchor="right"
                  open={openPaymentDrawer}>
                  {<AddPaymentForm isInflow={isInflow} title='Add new payment' open={openPaymentDrawer} onClose={handleClosePayment} />}
                </Drawer>
              </div>
            </Box>
          </Typography>
          <Typography>
            <Box sx={{ display: "flex", justifyContent: "flex-start", paddingTop: '10px', paddingBottom: '10px', marginLeft: '22px', width: '100%', fontWeight: "800" }}>
              <h3> {TabHeading} </h3>
              
            </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end", paddingTop: '10px', paddingBottom: '10px', marginRight: '22px', width: '100%', fontWeight: "800" }}>
            <FormGroup>
              <FormControlLabel control={<Checkbox checked={checkedExpandRow} onChange={handleChangeExpandRow} />} label="Show Attached Invoices in pdf report" />
            </FormGroup>
              <Button variant="contained" color="secondary" onClick={exportToExcel} style={{marginRight: '10px'}}> Export to Excel </Button>
              <Button variant="contained" color="secondary" onClick={downloadPdf} style={{marginRight: '10px'}}> Download PDF </Button>
            </Box>
          </Typography>
          <div style={{ width: '100%' }}>
            <div id='pdfContainer'>
            <TableContainer component={Paper} >
              <Table aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <TableCell className='tableHead' sx={{ fontSize: '0.80rem', fontWeight: '700', borderRight: '2px solid #F5F5F5', width: '50px' }}></TableCell>
                    <TableCell align="left" className='tableHead' sx={{ fontSize: '0.80rem', fontWeight: '700', borderRight: '2px solid #F5F5F5', width: '70px' }} >Trxn ID</TableCell>
                    <Tooltip disableFocusListener disableTouchListener title="Payment Date">
                      <TableCell align="left" className='tableHead' sx={{ fontSize: '0.80rem', fontWeight: '700', borderRight: '2px solid #F5F5F5', cursor: 'pointer' }} >Payment Date</TableCell>
                    </Tooltip>
                    <TableCell align="left" className='tableHead' sx={{ fontSize: '0.80rem', fontWeight: '700', borderRight: '2px solid #F5F5F5', width: '22%'}} >{userType}</TableCell>
                    <Tooltip disableFocusListener disableTouchListener title="Payment Amount">
                      <TableCell align="right" className='tableHead' sx={{ fontSize: '0.80rem', fontWeight: '700', borderRight: '2px solid #F5F5F5', cursor: 'pointer' }} >
                        Payment AMT.
                      </TableCell>
                    </Tooltip>
                    <Tooltip disableFocusListener disableTouchListener title="Total Applied">
                      <TableCell align="left" className='tableHead' sx={{ fontSize: '0.80rem', fontWeight: '700', borderRight: '2px solid #F5F5F5', cursor: 'pointer' }} >
                        Total Applied
                      </TableCell>
                    </Tooltip>
                    <Tooltip disableFocusListener disableTouchListener title="Total Unapplied">
                      <TableCell align="left" className='tableHead' sx={{ fontSize: '0.80rem', fontWeight: '700', borderRight: '2px solid #F5F5F5', cursor: 'pointer' }} >
                        Total Unapplied
                      </TableCell>
                    </Tooltip>
                    <TableCell align="left" className='tableHead' sx={{ fontSize: '0.80rem', fontWeight: '700', borderRight: '2px solid #F5F5F5' }} title="Status">Status</TableCell>
                    <TableCell align="left" className='tableHead' sx={{ fontSize: '0.80rem', fontWeight: '700', borderRight: '2px solid #F5F5F5' }} title="Status">Payment Mode</TableCell>
                    <TableCell align="center" className='tableHead' sx={{ fontSize: '0.80rem', fontWeight: '700', borderRight: '2px solid #F5F5F5' }} title="Actions">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row) => (
                    <Row key={row.name} row={row} scType={props.type} expandRow={checkedExpandRow}/>
                  ))}

                </TableBody>
              </Table>
            </TableContainer>
            </div>
          </div>
        </CardContent>
      </StyledCard>

      {/* Modern Delete Confirmation Dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={handleDeleteCancel}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        maxWidth="sm"
        fullWidth
        TransitionProps={{
          timeout: {
            enter: 400,
            exit: 200,
          },
        }}
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
            transform: deleteDialogOpen ? 'scale(1)' : 'scale(0.95)',
            transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
          }
        }}
        sx={{
          '& .MuiBackdrop-root': {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            backdropFilter: 'blur(4px)',
            transition: 'all 0.3s ease-in-out',
          },
          '& .MuiDialog-paper': {
            animation: deleteDialogOpen ? 'slideInUp 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)' : 'none',
          },
          '@keyframes slideInUp': {
            '0%': {
              transform: 'translateY(60px) scale(0.9)',
              opacity: 0,
            },
            '100%': {
              transform: 'translateY(0) scale(1)',
              opacity: 1,
            },
          },
        }}
      >
        <DialogTitle 
          id="delete-dialog-title" 
          sx={{ 
            backgroundColor: '#fef2f2', 
            borderBottom: '1px solid #fecaca',
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            py: 3,
            px: 3
          }}
        >
          <Box sx={{
            backgroundColor: '#fee2e2',
            borderRadius: '50%',
            p: 1.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <DeleteIcon sx={{ color: '#dc2626', fontSize: 28 }} />
          </Box>
          <Box>
            <Typography variant="h5" sx={{ 
              fontWeight: 600, 
              color: '#1f2937',
              fontSize: '1.25rem',
              lineHeight: 1.2
            }}>
              Delete Payment
            </Typography>
            <Typography variant="body2" sx={{ 
              color: '#6b7280', 
              mt: 0.5,
              fontSize: '0.875rem'
            }}>
              This action cannot be undone
            </Typography>
          </Box>
        </DialogTitle>
        
        <DialogContent sx={{ py: 4, px: 3 }}>
          <Typography 
            variant="body1" 
            sx={{ 
              color: '#1f2937',
              fontSize: '1.125rem',
              fontWeight: 400,
              lineHeight: 1.7,
              letterSpacing: '0.01em',
              pt: 2,
              pb: 1,
              mb: 3
            }}
          >
            Are you sure you want to delete this payment record? 
          </Typography>
          <Typography 
            variant="body2" 
            sx={{ 
              color: '#6b7280',
              fontSize: '0.95rem',
              lineHeight: 1.6,
              mb: 3
            }}
          >
            This will permanently remove all payment data and associated invoices from the system.
          </Typography>
          
          <Box sx={{ 
            backgroundColor: '#fef3c7', 
            border: '1px solid #f59e0b', 
            borderRadius: 2, 
            p: 3,
            display: 'flex',
            alignItems: 'flex-start',
            gap: 2
          }}>
            <Box sx={{
              backgroundColor: '#fbbf24',
              borderRadius: '50%',
              p: 0.5,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: 24,
              height: 24
            }}>
              <Typography sx={{ 
                color: '#ffffff', 
                fontSize: '0.875rem',
                fontWeight: 'bold'
              }}>
                !
              </Typography>
            </Box>
            <Box>
              <Typography variant="subtitle2" sx={{ 
                fontWeight: 600, 
                color: '#92400e',
                fontSize: '0.875rem',
                mb: 0.5
              }}>
                Important Warning
              </Typography>
              <Typography variant="body2" sx={{ 
                color: '#92400e',
                fontSize: '0.875rem',
                lineHeight: 1.5
              }}>
                All invoices linked to this payment will also be removed. This data cannot be recovered once deleted.
              </Typography>
            </Box>
          </Box>
        </DialogContent>
        
        <DialogActions sx={{ 
          backgroundColor: '#f9fafb', 
          borderTop: '1px solid #e5e7eb',
          px: 3,
          py: 2.5,
          gap: 1.5
        }}>
          <Button 
            onClick={handleDeleteCancel} 
            variant="outlined" 
            sx={{ 
              minWidth: 100,
              height: 40,
              textTransform: 'none',
              fontWeight: 500,
              borderColor: '#d1d5db',
              color: '#374151',
              '&:hover': {
                borderColor: '#6b7280',
                backgroundColor: '#e5e7eb',
                color: '#1f2937'
              }
            }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleDeleteConfirm} 
            variant="contained" 
            startIcon={<DeleteIcon sx={{ fontSize: 18 }} />}
            sx={{ 
              minWidth: 140,
              height: 40,
              textTransform: 'none',
              fontWeight: 600,
              backgroundColor: '#dc2626',
              '&:hover': {
                backgroundColor: '#b91c1c'
              },
              boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)'
            }}
          >
            Delete Payment
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
export default CashFlowData;
